import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { SessionService } from '@core/services/session.service';
import { RewardsService } from '@features/rewards/services/rewards.service';
import { CheckboxComponent } from '@core/components/checkbox/checkbox.component';

@Component({
  selector: 'app-rewards-requirements-modal',
  imports: [SvgIconComponent, CheckboxComponent],
  templateUrl: './rewards-requirements-modal.component.html',
  styleUrl: './rewards-requirements-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class RewardsRequirementsModalComponent {
  requirements = computed(() => {
    const fields = {
      balance: this.sessionService.balance().skins < 0.05,
      level: (this.sessionService.profile()?.level ?? 1000000) >= 10,
      discord:
        this.sessionService.discord().linked &&
        this.sessionService.discord().joined,
      name: this.sessionService.profile()?.name.includes('#TF2Hunt') ?? false,
      steamPublic: this.sessionService.profile()?.steamid !== '-1',
    };
    return {
      ...fields,
      eligible: Object.values(fields).every((value) => value),
    };
  });

  constructor(
    public sessionService: SessionService,
    private rewardsService: RewardsService
  ) {}

  handleRefresh() {
    this.rewardsService.claimFaucet();
  }
}
